// import {store1} from '../store/index'

var DataStore = require('../store');
var store = DataStore.default

// const fetchPOST =  () =>{
//     return 'store.state.url.URL_APP'
// }

const fetchPOST = () => {
  return store.state.kamio
}




// const getAgama = (uraian) => {
//   console.log(uraian);
//   fetch(store.state.url.URL_MASTER_AGAMA + "list", {
//     method: "POST",
//     headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//     },
//     body: JSON.stringify({
//       uraian: uraian
//     })
//   })
//     .then(res => res.json())
//     .then(res_data => {
//       console.log(res_data)
//       store.state.option_provinsi = res_data
//     });
// }



// const getAgama = (uraian) => {
//   fetch(store.state.url.URL_MASTER_AGAMA + "list", {
//     method: "POST",
//     headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//     },
//     body: JSON.stringify({
//         uraian: uraian
//     })
//   })
//     .then(res => res.json())
//     .then(res_data => {
//       console.log(res_data)
//       store.state.option_agama = res_data
//     });
// }

// const pekerjaan = () => {
//   // this.$store.commit("shoWLoading");
//   fetch(store.state.url.URL_MASTER_PEKERJAAN + "list", {
//       method: "POST",
//       headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//       },
//       // body: JSON.stringify({ 
//       //   uraian: uraian
//       // })
//   })
//       .then(res => res.json())
//       .then(res_data => {
//         store.state.list_pekerjaan = res_data.data
//           // this.list_data = res_data.data;
//           // this.page_last = res_data.jmlData;
//           // this.$store.commit("hideLoading");
//           console.log('pekerjaan di panggil');
//           // console.log(res_data);
//   });
// }

const pekerjaan = () => {
  fetch(store.state.url.URL_MASTER_PEKERJAAN + "list", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => { 
      store.state.listPekerjaan = res_data
    });
}
const agama = () => {
  fetch(store.state.url.URL_MASTER_AGAMA + "list1", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => { 
      store.state.listAgama = res_data
    });
}

const pendidikan = () => {
  fetch(store.state.url.URL_MASTER_PENDIDIKAN + "list", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => { 
      store.state.listPendidikan = res_data
    });
}
const shdk = () => {
  fetch(store.state.url.URL_MASTER_SHDK + "list", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => { 
      store.state.listShdk = res_data
      console.log('aaaa', res_data);
    });
}


// const getKec = (kab_kota) => {
//   fetch(store.state.url.URL_DATAMASTER_KECAMATAN + "list", {
//     method: "POST",
//     headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//     },
//     body: JSON.stringify({
//       m_kabupaten: kab_kota
//     })
//   })
//     .then(res => res.json())
//     .then(res_data => {
//       console.log(res_data)
//       store.state.option_kecamatan = res_data
//     });
// }

// const getKecSingle = () => {
//   fetch(store.state.url.URL_DATAMASTER_KECAMATAN + "listSingle", {
//     method: "GET",
//     headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//     }
//   })
//     .then(res => res.json())
//     .then(res_data => {
//       // console.log(res_data)
//       store.state.listKec = res_data
//     });
// }



// const getDesKel = (kecamatan) => {
//   // console.log(kecamatan)
//   fetch(store.state.url.URL_DATAMASTER_DES_KEL + "list", {
//     method: "POST",
//     headers: {
//       "content-type": "application/json",
//       authorization: "kikensbatara " + localStorage.token
//     },
//     body: JSON.stringify({
//       kecamatan: kecamatan
//     })
//   })
//     .then(res => res.json())
//     .then(res_data => {
//       // console.log(res_data)
//       store.state.listDesKel = res_data
//     });
// }














module.exports = { 
  pekerjaan : pekerjaan,
  agama : agama,
  pendidikan : pendidikan,
  shdk : shdk,

}